<template>
  <div id="container">
    <h2>{{ $t('supplierDetails.informations.informations') }}</h2>

    <div id="supplier-info">
      <div id="info-first-row">
        <div class="info">
          <p class="label">{{ $t('supplierDetails.informations.street') }}</p>
          <p class="value">{{ supplierData.address.street }}</p>
        </div>

        <div class="info">
          <p class="label">
            {{ $t('supplierDetails.informations.houseNumber') }}
          </p>
          <p class="value">{{ supplierData.address.houseNumber }}</p>
        </div>

        <div class="info">
          <p class="label">{{ $t('supplierDetails.informations.ZIPCode') }}</p>
          <p class="value">{{ supplierData.address.ZIPCode }}</p>
        </div>

        <div class="info">
          <p class="label">{{ $t('supplierDetails.informations.city') }}</p>
          <p class="value">{{ supplierData.address.city }}</p>
        </div>
      </div>

      <div id="info-second-row">
        <div class="info">
          <p class="label">
            {{ $t('supplierDetails.informations.SAPNumber') }}
          </p>
          <p class="value">{{ supplierData.SAPNumber }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./SupplierInformation.script.ts" lang="ts"></script>
<style scoped lang="scss" src="./SupplierInformation.styles.scss"></style>
